import React from 'react';
import { ResponsivePie } from "@nivo/pie"

// Documentation: https://nivo.rocks/
// ---- Notes from Nivo! ----
// • Make sure parent container have a defined height when using
// • Responsive component, otherwise height will be 0 and
// • No chart will be rendered.
// • Website examples showcase many properties,
// • you'll often use just a few of them.

const ExplotPlotPie = ({
  className = '',
  colors = undefined,
  data = [],
  height = undefined,
  innerRadius = undefined,
  margin = undefined,
  title = '',
  width = '',
  ...props
}) => (
  <div className={`points-allocation-chart ${className ? className : ''}`}>
    <h2 className="points-allocation-chart__title mt-4 mb-0 text-center">{title}</h2>
    <div className="points-allocation-chart__wrapper" style={{ height, width, margin: '0 auto' }}>
      <ResponsivePie
        animate={true}
        colors={colors}
        // data={data.sort((a, b) => a.value - b.value)}
        data={data}
        innerRadius={innerRadius}
        margin={margin}
        motionDamping={15}
        motionStiffness={90}
        enableRadialLabels={true}
        radialLabel={d => (
          <React.Fragment>
            <tspan className="font-weight-bold" x="0" dy="0">
              {d.label.length > 30 ? `${d.label.substring(0, 29)}...` : d.label}
            </tspan>
            <tspan>{` (${d.value} ${d.pointsLabel})`}</tspan>
            {/* <tspan x="0" dy="1.2em">
              Estimated Position: {d.position}
            </tspan> */}
          </React.Fragment>
        )}
        enableSlicesLabels={false}
        radialLabelsTextXOffset={10}
        radialLabelsTextColor="#222222"
        radialLabelsLinkOffset={2}
        radialLabelsLinkDiagonalLength={0}
        radialLabelsLinkHorizontalLength={20}
        radialLabelsLinkStrokeWidth={1}
        radialLabelsLinkColor={{ from: 'color' }}
        slicesLabelsTextColor="#fff"
        padAngle={2}
        startAngle={-350}
        {...props}
      />
    </div>
  </div>
);

ExplotPlotPie.defaultProps = {
  colors: { scheme: 'category10' },
  data: [],
  height: '450px',
  width: '100%',
  innerRadius: 0.6,
  margin: { top: 75, right: 275, bottom: 75, left: 275 }
};

export default ExplotPlotPie;
